module.exports = __webpack_public_path__ + "static/media/Inter-Light.5a8cd28e.ttf";